/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 投诉建议列表显示
    ComplaintProposalPraiseListShow ({ commit }, data) {
        return axios.post(http + '/advice/show', data).then(res => {
            return res.data
        })
    },
    // 投诉建议评论新增
    ComplaintProposalPraiseCommentAdd ({ commit }, data) {
        return axios.post(http + '/advice/add', data).then(res => {
            return res.data
        })
    },
    // 投诉建议评论列表
    CommentListShow ({ commit }, data) {
        return axios.post(http + '/advice/show_comment', data).then(res => {
            return res.data
        })
    },
    // 投诉建议评论删除
    ComplaintProposalPraiseCommentDelete ({ commit }, data) {
        return axios.post(http + '/advice/delete', data).then(res => {
            return res.data
        })
    },
    ExportComplaintProposalPraise ({ commit }, data) {
        return axios({ method: 'post', url: http + '/advice/show', data: data, responseType: 'blob' }).then(res => {
            return res.data
        })
    },
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const ComplaintProposalPraiseModule = {
    state,
    getters,
    actions,
    mutations
}
export default ComplaintProposalPraiseModule
